<body>
  <div class="header">{{ title }}</div>
  <div class="comment-input" *ngIf="userLogged">
    <img class="user-logged-avatar" [src]="user.avatar_url" alt="" />
    <app-input-comment (send)="onSendComment($event, user)"
      [placeholder]="'dashboard.popup-comments.your-comment' | translate" [taggable]="false" />
  </div>

  <div class="content">
    <div class="divider"></div>
    <div class="comments-count" translate>
      <span>{{ commentsCount }}</span>
      watch.comment_modal.counter_label
    </div>
    <div class="comment-list" infiniteScroll [infiniteScrollDistance]="1.1" [infiniteScrollThrottle]="70"
      [infiniteScrollDisabled]="loading$ | async" [fromRoot]="true" [infiniteScrollContainer]="scrollContainerSelector"
      (scrolled)="onScrollBottom()">

      <app-comment-block [commentType]="commentType" *ngFor="let comment of comments$ | async"
        (onMoreClick)="onMoreClick($event)" (deleteCommentElement)="deleteComment($event)"
        (subCommentsCountEvent)="subCommentsCountEvent($event)" [isActionClick]="comment.id === actionCommentClickId"
        [comment]="comment" [user]="user" [videoCommentId]="this.videoId"
        [focusComment]="focusCommentId === comment.id" />


    </div>
  </div>

  <div class="skeletons" *ngIf="loading$ | async">
    <div *ngFor="let i of [0, 0]">
      <p-skeleton size="68px" shape="circle"></p-skeleton>
      <p-skeleton class="skeleton-rec" height="4em"></p-skeleton>
    </div>
  </div>
</body>